import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: 'rgb(13, 35, 64)', // Dark Blue
      light: 'rgb(50, 65, 80)', // Steel Gray
      contrastText: 'rgb(245, 245, 245)', // Off-White
    },
    secondary: {
      main: 'rgb(255, 90, 60)', // Red-Orange
      contrastText: 'rgb(245, 245, 245)', // Off-White
    },
    background: {
      default: 'rgb(245, 245, 245)', // Off-White
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '8px 24px',
        },
      },
    },
  },
});

export default theme; 